<router-outlet></router-outlet>
<div *ngIf="isNotificationModalVisible"
    class="ant-notification-notice ant-notification-notice-closable  ng-trigger ng-trigger-notificationMotion countryNotification"
    ng-reflect-ng-class="countryNotification" style="opacity: 1; transform: translateX(0px);">
    <div class="ant-notification-notice-content">
        <div class="ant-notification-notice-content ">
            <div class="">
                <div class="ant-notification-notice-message ">We'd like to show you notifications for</div>
                <div class="ant-notification-notice-description ">
                    <div class="font_inter"
                        style="margin-bottom: 10px; color: #212529; font-size: 14px;font-weight: 400; display: flex; align-items: center;">
                        <img src="https://singx.co/singx/images/percentage_icon_square.png"
                            class="img-responsive mobilelogoalign" height="30px" style="margin-right: 10px;"
                            alt="Notification Icon">
                        Special Offers
                    </div>
                    <div class="clearfix"></div>
                    <div class="font_inter"
                        style="margin-bottom: 10px; color: #212529; font-size: 14px;font-weight: 400; display: flex; align-items: center;">
                        <img src="https://singx.co/singx/images/currencies_icon_square.png"
                            class="img-responsive mobilelogoalign" height="30px" style="margin-right: 10px;"
                            alt="Notification Icon">
                        Transaction Updates
                    </div>
                    <div class="text-right">
                        <button class="btn btn-light mr-2" (click)="handleCancel()">NO
                            THANKS</button>
                        <button class="btn btn-danger bg-orange text-white" (click)="handleOk()">ALLOW</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>